export const useSetTokenExpiration = () => {
  const env = useRuntimeConfig();

  const tokenExpiresAt = useCookie<number | null>("token_exp", {
    path: "/",
    maxAge: 60 * 60 * 24 * 30,
    domain: env.public.hurstDomain as string | undefined,
  });

  return (tokenExpiresIn: number | null) => {
    if (!tokenExpiresIn) {
      tokenExpiresAt.value = null;

      return;
    }

    tokenExpiresAt.value = new Date().getTime() + tokenExpiresIn * 1000;
    refreshCookie("token_exp");
  };
};
